import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import CustomInput from '../../../../../../components/common/Input/input';
import SettingsBreadcrumb from '../../../../../../components/SettingsBreadcrumb';
import './editar-modelo-1.scss';
import BibliotecaModal from '../../BibliotecaModal/BibliotecaModal';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  Flex,
  Heading,
  Box,
  Button,
  FormLabel,
  FormControl,
  Image,
  IconButton,
  Select,
  Text,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  VStack,
  Spinner,
} from '@chakra-ui/react'
import * as api from '../../../../../../api/outrasPaginas';
import Swal from 'sweetalert2';
import { FaEye, FaImage, FaMinus, FaPlus, FaTimes } from 'react-icons/fa';
import QuillEditor from '../../../../../../components/common/QuillEditor';

interface Imagem {
  id: number;
  imagem: string;
  imagemPreview: string;
  posicaoImagem: string;
  tipo?: 'image' | 'video'; 
}

interface Secao {
  id: number;
  titulo: string;
  descricao: string;
  aberto: boolean;
  imagem: Imagem[];
}

const EditarModelo1: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formValues, setFormValues] = useState<{
    titulo: { value: string; error: boolean };
    dscUrl: { value: string; error: boolean };
    tituloSelecao: { value: string; error: boolean };
  }>({
    titulo: { value: '', error: false },
    dscUrl: { value: '', error: false },
    tituloSelecao: { value: '', error: false },
  });
  const [seqUsuario, setSeqUsuario] = useState<any[]>([]);
  const [isLoadingButton, setLoadingButton] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [bibliotecaOpen, setBibliotecaOpen] = useState<boolean>(false);
  const [secaoAtualId, setSecaoAtualId] = useState<number | null>(null);
  const [txtHtml, setTxtHtml] = useState('');
  const [siteExterno, setSiteExterno] = useState('0');
  const [submitAttempted, setSubmitAttempted] = useState<boolean>(false);
  const [previewSelecao, setPreviewSelecao] = useState<Secao[]>([]);

  const {
    isOpen: isPreviewAberto,
    onOpen: onPreviewAberto,
    onClose: onPreviewFechado
  } = useDisclosure()

  const videoExts = ['.mp4', '.webm', '.ogg'];
  const [selecao, setSelecao] = useState<Secao[]>([
    {
      id: 1,
      titulo: '',
      descricao: '',
      aberto: true,
      imagem: [],
    },
  ]);

  const [listaPosicaoImagem, setListaPosicaoImagem] = useState<
    { codPropriedade: number; dscPropriedade: string }[]
  >([]);

  const ordenarImagensVisualmente = (imagens: Imagem[]) => {
    const esquerda = imagens.filter(img => getLabel(img.posicaoImagem) === 'Esquerda');
    const centro = imagens.filter(img => getLabel(img.posicaoImagem) === 'Centro');
    const direita = imagens.filter(img => getLabel(img.posicaoImagem) === 'Direita');
    return [...esquerda, ...centro, ...direita];
  };
  
  const getLabel = (codPropriedade: string) => {
    return listaPosicaoImagem.find(opt => opt.codPropriedade.toString() === codPropriedade)?.dscPropriedade || '';
  };
  
  const abrirModalDePreview = () => {
    const clone = JSON.parse(JSON.stringify(selecao));
    setPreviewSelecao(clone);
    onPreviewAberto();
  };

  useEffect(() => {
    api.listarPosicaoImagem()
      .then(data => {
        setListaPosicaoImagem(data);
      })
      .catch(err => {
        console.error("Erro ao listar posições de imagem", err);
      });
  }, []);

  useEffect(() => {
    fetchObterPagina();
  }, []);

  const fetchObterPagina = async () => {
    setIsLoading(true);
    try {
      const paginasData = await api.obterPagina(Number(id));
      if (paginasData.jsonModelo) {
        const parsedModelo = JSON.parse(paginasData.jsonModelo);
        setFormValues({
          titulo: { value: paginasData.nomPagina, error: false },
          dscUrl: { value: paginasData.dscUrl, error: false },
          tituloSelecao: { value: parsedModelo.titulo || '', error: false },
        });
        const secoesMapeadas = parsedModelo.secoes.map((secao: any) => {
          let imagensTratadas: Imagem[] = [];

          if (secao.imagem) {
            const raw = Array.isArray(secao.imagem)
              ? secao.imagem
              : typeof secao.imagem === 'object'
                ? [secao.imagem]
                : [{ url: secao.imagem }];

            imagensTratadas = raw.map((img: any) => {
              const url = img.url as string;
              const cleanUrl = url.split('?')[0].toLowerCase();
              const isVideo = videoExts.some(ext => cleanUrl.endsWith(ext));

              return {
                id: img.id ?? Date.now(),
                imagem: url,
                imagemPreview: url,
                posicaoImagem: (
                  img.codPropriedade ?? img.posicaoImagem
                )?.toString() || '',
                tipo: isVideo ? 'video' : 'image'
              };
            });
          }

          return {
            id: secao.id,
            titulo: secao.titulo,
            descricao: secao.descricao,
            aberto: secao.aberto,
            imagem: imagensTratadas,
          };
        });

        setSelecao(secoesMapeadas);
      } else {
        const { nomPagina, dscUrl, txtHtml } = paginasData;
        setFormValues({
          titulo: { value: nomPagina, error: false },
          dscUrl: { value: dscUrl, error: false },
          tituloSelecao: { value: '', error: false },
        });
      }
      setTxtHtml(paginasData.txtHtml || '');
      setSiteExterno(paginasData.numHtmlProprio ? String(paginasData.numHtmlProprio) : '0');
    } catch (error) {
      console.error("Erro ao buscar dados da página:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const abrirBlibliotecaDeFotos = (secaoId: number) => {
    setSecaoAtualId(secaoId);
    setBibliotecaOpen(true);
  };

  const handleSelectImageFromBiblioteca = (media: any) => {
    if (secaoAtualId == null) return;
    const url = decodeURIComponent(media.dscUriCdn || media.dscMidia);
    const cleanUrl = url.split('?')[0].toLowerCase();
    const isVideo = videoExts.some(ext => cleanUrl.endsWith(ext));

    setSelecao(prev =>
      prev.map(secao =>
        secao.id === secaoAtualId
          ? {
            ...secao,
            imagem: [
              ...secao.imagem,
              {
                id: Date.now(),
                imagem: url,
                imagemPreview: url,
                posicaoImagem: '',
                tipo: isVideo ? 'video' : 'image'
              }
            ]
          }
          : secao
      )
    );
  };

  useEffect(() => {
    const storedUsuario = localStorage.getItem('dadosUsuario');
    if (storedUsuario) {
      try {
        const usuario = JSON.parse(storedUsuario);
        setSeqUsuario(usuario.seqUsuario);
      } catch (error) {
        console.error("Erro ao recuperar os dados do usuário:", error);
      }
    }
  }, []);

  const handleFieldChange = (field: keyof typeof formValues, value: any) => {
    setFormValues({ ...formValues, [field]: { value, error: false } });
  };

  const isFormValid = () => {
    const tituloValue = formValues.titulo.value || "";
    const dscUrlValue = formValues.dscUrl.value || "";
    if (!tituloValue.trim() || !dscUrlValue.trim()) return false;
    const isValido =
      selecao.length > 0 &&
      selecao.every(secao =>
        secao.titulo.trim() !== "" && secao.descricao.trim() !== ""
      );
    return isValido;
  };

  const formataData = (date: Date) => {
    const ano = date.getFullYear();
    const mes = String(date.getMonth() + 1).padStart(2, "0");
    const dia = String(date.getDate()).padStart(2, "0");
    return `${ano}-${mes}-${dia}`;
  };

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitAttempted(true);
    setLoadingButton(true);

    for (const secao of selecao) {
      for (const img of secao.imagem) {
        if (img.imagem && !img.posicaoImagem) {
          Swal.fire({
            icon: 'warning',
            title: 'Atenção!',
            text: 'Selecione uma opção válida para a posição de todas as imagens.',
            confirmButtonText: 'OK',
          });
          setLoadingButton(false);
          return;
        }
      }
    }

    try {
      const updatedSelecao = selecao.map(secao => ({
        ...secao,
        imagem: secao.imagem.map(img => {
          const posicao = listaPosicaoImagem.find(option =>
            option.codPropriedade.toString() === img.posicaoImagem
          );
          return {
            id: img.id,
            url: img.imagem,
            codPropriedade: posicao ? posicao.codPropriedade : null,
            dscPropriedade: posicao ? posicao.dscPropriedade : null,
          };
        }),
      }));

      const jsonModeloData = {
        codModeloPagina: 1,
        tituloGeral: formValues.titulo.value,
        secoes: selecao.map(secao => ({
          id: secao.id,
          titulo: secao.titulo,
          descricao: secao.descricao,
          aberto: secao.aberto,
          imagem: updatedSelecao.find(s => s.id === secao.id)?.imagem || []
        }))
      };

      const params = {
        seqPagina: Number(id),
        nomPagina: formValues.titulo.value || null,
        dscUrl: formValues.dscUrl.value,
        txtHtml: null,
        numHtmlProprio: 0,
        numBloqueada: 0,
        sitRegistro: 1,
        datInativo: null,
        codModeloPagina: 1,
        jsonModelo: JSON.stringify(jsonModeloData)
      };

      await api.editarPagina(params);
      setLoadingButton(false);
      Swal.fire({
        icon: "success",
        title: "Sucesso!",
        text: "Página editada com sucesso.",
        confirmButtonColor: "#1789FC",
        confirmButtonText: "OK",
      }).then(() => {
        navigate("/cms/edicao-cidade-inteligente/outras-paginas");
      });
    } catch (error) {
      console.error("Erro ao editar página:", error);
      if (typeof error === "string" && error.includes("Erro ao atualizar a Pagina")) {
        Swal.fire({
          icon: "error",
          title: "Ocorreu um erro!",
          text: "O nome da página já está em uso. Por favor, escolha outro.",
          confirmButtonColor: "#1789FC",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Ocorreu um erro!",
          text: "Erro ao editar página. Tente novamente mais tarde.",
          confirmButtonColor: "#1789FC",
          confirmButtonText: "OK",
        });
      }
      setLoadingButton(false);
    }
  };

  const handleAddSelecao = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    const novaSelecao: Secao = {
      id: Date.now(),
      titulo: '',
      descricao: '',
      aberto: true,
      imagem: [],
    };
    setSelecao(prevSelecao => [...prevSelecao, novaSelecao]);
  };

  const handleRemoverSelecao = (id: number) => {
    setSelecao(prevSelecao => prevSelecao.filter(s => s.id !== id));
  };

  const toggleSelecao = (id: number) => {
    setSelecao(prevSelecao =>
      prevSelecao.map(s =>
        s.id === id ? { ...s, aberto: !s.aberto } : s
      )
    );
  };

  const handleRemoveImagem = (secaoId: number, imgId: number) => {
    setSelecao(prevSelecao =>
      prevSelecao.map(s =>
        s.id === secaoId ? { ...s, imagem: s.imagem.filter(img => img.id !== imgId) } : s
      )
    );
  };

  const handleSelecaoChange = (id: number, field: string, value: string) => {
    setSelecao(prevSelecao =>
      prevSelecao.map(s =>
        s.id === id ? { ...s, [field]: value } : s
      )
    );
  };

  const handleAtualizarPosicaoImagem = (secaoId: number, imgId: number, posicaoImagem: string) => {
    setSelecao(prevSelecao =>
      prevSelecao.map(s =>
        s.id === secaoId
          ? { ...s, imagem: s.imagem.map(img => img.id === imgId ? { ...img, posicaoImagem } : img) }
          : s
      )
    );
  };

  const MEDIA_BOX_STYLE = {
    w: '300px',
    h: '350px',
    borderRadius: '6px',
    bg: '#f4f4f4',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
  };

  const indexSecoesAbertasPreview = previewSelecao
  .map((secao, index) => (secao.aberto ? index : null))
  .filter((index) => index !== null) as number[];
  
  const carregarPreview = () => (
    <Accordion 
      allowMultiple 
      defaultIndex={selecao.map((_, i) => i)}
      index={indexSecoesAbertasPreview}
      onChange={(expandedIndices: number | number[]) => {
        const indicesArray = Array.isArray(expandedIndices)
          ? expandedIndices
          : [expandedIndices];
    
          setPreviewSelecao((prev) =>
            prev.map((secao, index) => ({
            ...secao,
            aberto: indicesArray.includes(index),
          }))
        );
      }}
      >
      {previewSelecao.map((secao, idx) => {
        const imgs = ordenarImagensVisualmente(secao.imagem);
        const count = imgs.length;
        
        const Media = (img: Imagem) =>
          img.tipo === 'video' ? (
            <Box key={img.id} {...MEDIA_BOX_STYLE}>
              <video
                src={img.imagemPreview}
                controls
                style={{
                  maxWidth: '100%',
                  maxHeight: '100%',
                  objectFit: 'contain',
                  borderRadius: '4px',
                }}
              />
            </Box>
          ) : (
            <Box key={img.id} {...MEDIA_BOX_STYLE}>
              <Image
                src={img.imagemPreview}
                alt="Imagem da seção"
                maxW="100%"
                maxH="100%"
                objectFit="contain"
                borderRadius="4px"
              />
            </Box>
          );
        
  
        return (
          <AccordionItem key={secao.id} border="1px solid #ccc" borderRadius="md" mb={6}>
            <h2>
              <AccordionButton _expanded={{ bg: '#f2f2f2' }} py={4}>
                <Box flex="1" textAlign="left" fontWeight="bold" fontSize="lg">
                  {secao.titulo || `Seção ${idx + 1}`}
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </h2>
  
            <AccordionPanel px={6} py={4}>
              {count === 1 ? (
                (() => {
                  const img = imgs[0];
                  const prop = listaPosicaoImagem.find(
                    (o) => o.codPropriedade.toString() === img.posicaoImagem
                  )?.dscPropriedade;
  
                  if (prop === 'Esquerda' || !prop) {
                    return (
                      <Flex direction={['column', 'row']} gap={6} align="flex-start">
                        <Box>{Media(img)}</Box>
                        <Box flex="1">
                          <Text
                            fontSize="md"
                            textAlign="justify"
                            lineHeight="1.6"
                            dangerouslySetInnerHTML={{ __html: secao.descricao }}
                          />
                        </Box>
                      </Flex>
                    );
                  }
  
                  if (prop === 'Direita') {
                    return (
                      <Flex direction={['column', 'row']} gap={6} align="flex-start">
                        <Box flex="1">
                          <Text
                            fontSize="md"
                            textAlign="justify"
                            lineHeight="1.6"
                            dangerouslySetInnerHTML={{ __html: secao.descricao }}
                          />
                        </Box>
                        <Box>{Media(img)}</Box>
                      </Flex>
                    );
                  }
  
                  return (
                    <VStack spacing={4}>
                      {Media(img)}
                      <Text
                        fontSize="md"
                        textAlign="center"
                        lineHeight="1.6"
                        dangerouslySetInnerHTML={{ __html: secao.descricao }}
                      />
                    </VStack>
                  );
                })()
              ) : (
                <VStack spacing={4}>
                  <Flex wrap="wrap" justify="center" gap={4}>
                    {imgs.map(Media)}
                  </Flex>
                  <Text
                    fontSize="md"
                    textAlign="center"
                    lineHeight="1.6"
                    dangerouslySetInnerHTML={{ __html: secao.descricao }}
                  />
                </VStack>
              )}
            </AccordionPanel>
          </AccordionItem>
        );
      })}
    </Accordion>
  );

  return (
    <Flex direction="column" padding="40px" backgroundColor="#fafafa" width="100%" height="100%" overflow="hidden">
      <SettingsBreadcrumb />
      <Heading mt="30px" fontWeight="600" fontSize="21px" color="#6F6F6F" w="100%">
        Editar Modelo 1: Apresentação de Secretarias
      </Heading>
      {isLoading ? (
        <Flex
          justify="center"
          align="center"
          direction="column"
          w="70%"
          h="90%"
          position='fixed'
        >
          <Spinner size="xl" color="blue.500" />
        </Flex>
      ) : (
        <Box m="40px 0" w="100%">
          <form onSubmit={handleFormSubmit}>
            <div className="row mb-3">
              <div className="col-md-6 mb-4">
                <FormControl isRequired isInvalid={formValues.titulo.error}>
                  <FormLabel mb="8px">Título Geral</FormLabel>
                  <CustomInput
                    placeholder="Digite um título"
                    value={formValues.titulo.value}
                    maxLength={100}
                    onChange={(e: any) => handleFieldChange('titulo', e.target.value)}
                  />
                </FormControl>
              </div>
              <div className="col-md-6 mb-4">
                <FormControl isRequired isInvalid={formValues.dscUrl.error}>
                  <FormLabel mb="8px">URL da Página</FormLabel>
                  <CustomInput
                    placeholder="Digite uma URL"
                    value={formValues.dscUrl.value}
                    onChange={(e) => handleFieldChange('dscUrl', e.target.value)}
                    maxLength={512}
                  />
                </FormControl>
              </div>
            </div>
            <Box mb="20px">
              {selecao.map((s, index) => {
                const secaoErro = !s.aberto && submitAttempted && s.imagem.some(img => img.imagem && !img.posicaoImagem);
                return (
                  <Box
                    key={s.id}
                    borderWidth="1px"
                    borderRadius="md"
                    p="20px"
                    mb="10px"
                    borderColor={secaoErro ? 'red.500' : 'gray.200'}
                  >
                    <Flex justifyContent="space-between" alignItems="center" mb="10px">
                      <Heading as="h5" size="sm">
                        {s.titulo || `Seção ${index + 1}`}
                      </Heading>
                      <Flex>
                        <Button variant="ghost" size="xs" onClick={() => toggleSelecao(s.id)} mr="2">
                          {s.aberto ? <FaMinus /> : <FaPlus />}
                        </Button>
                        <Button variant="ghost" size="xs" colorScheme="red" onClick={() => handleRemoverSelecao(s.id)}>
                          <FaTimes />
                        </Button>
                      </Flex>
                    </Flex>
                    {s.aberto && (
                      <Box>
                        <FormControl mb="10px" isRequired>
                          <FormLabel>Título</FormLabel>
                          <CustomInput
                            value={s.titulo}
                            onChange={(e) => handleSelecaoChange(s.id, 'titulo', e.target.value)}
                            placeholder="Digite o título da seção"
                          />
                        </FormControl>
                        <FormControl mb="10px">
                          <FormLabel>Mídia da Seção</FormLabel>
                          <Flex wrap="wrap" gap="20px">
                            {s.imagem.map(img => (
                              <Box
                                key={img.id}
                                borderWidth="1px"
                                borderRadius="md"
                                p="10px"
                                bg="#FFF"
                                boxShadow="md"
                                position="relative"
                                cursor="pointer"
                              >
                                <Box
                                  w="150px"
                                  h="100px"
                                  bg="#f0f0f0"
                                  borderRadius="4px"
                                  overflow="hidden"
                                  mx="auto"
                                >
                                  {img.tipo === 'video' ? (
                                    <video
                                      src={img.imagemPreview}
                                      controls
                                      muted
                                      playsInline
                                      style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'contain',
                                        display: 'block'
                                      }}
                                      onClick={e => e.stopPropagation()}
                                    />
                                  ) : (
                                    <Image
                                      src={img.imagemPreview}
                                      alt="Preview da mídia"
                                      w="100%"
                                      h="100%"
                                      objectFit="contain"
                                      display="block"
                                      onClick={e => e.stopPropagation()}
                                    />
                                  )}
                                </Box>

                                <IconButton
                                  icon={<FaTimes />}
                                  size="xs"
                                  colorScheme="red"
                                  position="absolute"
                                  top="2"
                                  right="2"
                                  borderRadius="full"
                                  aria-label="Remover mídia"
                                  onClick={e => {
                                    e.stopPropagation();
                                    handleRemoveImagem(s.id, img.id);
                                  }}
                                />

                                <Select
                                  mt="10px"
                                  value={img.posicaoImagem}
                                  onChange={e => handleAtualizarPosicaoImagem(s.id, img.id, e.target.value)}
                                  borderColor={
                                    submitAttempted && img.imagem && !img.posicaoImagem ? 'red.500' : undefined
                                  }
                                >
                                  <option value="" disabled>Posição</option>
                                  {listaPosicaoImagem.map(opt => (
                                    <option key={opt.codPropriedade} value={opt.codPropriedade}>
                                      {opt.dscPropriedade}
                                    </option>
                                  ))}
                                </Select>
                              </Box>
                            ))}

                            <Button
                              variant="outline"
                              onClick={() => abrirBlibliotecaDeFotos(s.id)}>
                              <FaImage color="gray" size="15px" />
                              <Text pl="6px" mt="4px" fontSize="sm">
                                Adicionar Mídia
                              </Text>
                            </Button>
                          </Flex>
                        </FormControl>
                        <FormControl mb="10px" isRequired>
                          <FormLabel>Descrição</FormLabel>
                          <QuillEditor
                            value={s.descricao || ""}
                            placeholder={"Digite a descrição da seção"}
                            onChange={(content: string) => handleSelecaoChange(s.id, "descricao", content)}
                          />
                        </FormControl>
                      </Box>
                    )}
                  </Box>
                );
              })}
              <Button onClick={handleAddSelecao} _hover={{ opacity: 0.8 }} leftIcon={<FaPlus />} bgColor="#1665D8" color="#FFF">
                Adicionar Seção
              </Button>
            </Box>
            <Flex mt="35px" justifyContent="end">
              <Button m="6px" onClick={() => navigate("/cms/edicao-cidade-inteligente/outras-paginas")}>
                Desistir
              </Button>
              <Button
                mt="6px"
                leftIcon={<FaEye />}
                variant="outline"
                onClick={abrirModalDePreview}
              >
                Ver Preview
              </Button>
              <Button
                type="submit"
                m="6px"
                color="#FFF"
                bgColor="#1665D8"
                _hover={{ opacity: 0.8 }}
                isDisabled={!isFormValid()}
                isLoading={isLoadingButton}
                loadingText="Editando..."
              >
                Editar Página Modelo
              </Button>
            </Flex>
          </form>
        </Box>
      )}

      <BibliotecaModal
        isOpen={bibliotecaOpen}
        onClose={() => setBibliotecaOpen(false)}
        onSelectImage={handleSelectImageFromBiblioteca}
      />
      <Modal isOpen={isPreviewAberto} onClose={onPreviewFechado} size="full" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader color={'#004a7f'} fontWeight={'bold'}>{formValues.titulo.value}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {carregarPreview()}
        </ModalBody>
        <ModalFooter>
          <Button onClick={onPreviewFechado}>Fechar</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
    </Flex>
  );
};

export default EditarModelo1;
